/* eslint-disable react-hooks/rules-of-hooks */
import { TextLink } from '@oneaudi/unified-web-components';
import React, { useCallback } from 'react';
import { UeElement } from '@oneaudi/falcon-tools';
import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import type { LinkProps } from '../../EditorContentTypes';
import { useTrackingManager } from '../../context/useTrackingManager';

export interface CTAsProps {
  readonly links: LinkProps[];
  readonly moduleIndex: number;
  readonly property0Text?: string;
  readonly property1Text?: string;
}

const CTAs: React.FC<CTAsProps> = ({
  links,
  moduleIndex,
  property0Text,
  property1Text,
}: CTAsProps) => {
  if (links.length === 0) {
    return null;
  }
  const trackingManager = useTrackingManager();
  const linkTracking = useCallback((href: string, text: string, linkIndex: number) => {
    trackingManager.click(href, text, moduleIndex, linkIndex);
  }, []);
  return (
    <>
      {links.map(({ href, text, ariaLabel }, i) => {
        return (
          <TextLink
            aria-label={ariaLabel}
            margin={[SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_300, 0, 0]}
            variant="standalone"
            iconPosition="trailing"
            icon="external-link"
            href={href}
            key={i}
            data-testid="cta"
            size="md"
            onClick={() => {
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              if (linkTracking) {
                linkTracking(href, text, i + 1);
              }
            }}
          >
            <UeElement type="text" property={i === 0 ? property0Text : property1Text} label="Text">
              {text}
            </UeElement>
          </TextLink>
        );
      })}
    </>
  );
};

export default CTAs;
